/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free text to binary converter. Turn text into 8-bit binary and decode binary back to text. UTF-8 safe, runs in your browser.`)
};

const es_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de texto a binario. Convierte texto en binario de 8 bits y decodifica binario de vuelta a texto. Compatible con UTF-8, se ejecuta en tu navegador.`)
};

const de_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Text-zu-Binär-Konverter. Wandle Text in 8-Bit-Binärcode um und dekodiere Binärcode zurück in Text. UTF-8-sicher, läuft in deinem Browser.`)
};

const nl_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis tekst-naar-binair converter. Zet tekst om in 8-bits binair en decodeer binair terug naar tekst. UTF-8 veilig, werkt in uw browser.`)
};

const fr_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur gratuit de texte en binaire. Convertissez du texte en binaire 8 bits et décodez le binaire en texte. Compatible UTF-8, fonctionne dans votre navigateur.`)
};

const it_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore da testo a binario gratuito. Converti il testo in binario a 8 bit e decodifica il binario di nuovo in testo. Sicuro per UTF-8, funziona nel tuo browser.`)
};

const pt_br2_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de texto para binário. Converta texto em binário de 8 bits e decodifique binário de volta para texto. Seguro para UTF-8, funciona no seu navegador.`)
};

const pt_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de texto para binário gratuito. Converta texto em binário de 8 bits e descodifique binário de volta para texto. Seguro para UTF-8, funciona no seu navegador.`)
};

const ja_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストをバイナリに変換する無料ツール。テキストを 8 ビットのバイナリに変換し、バイナリをテキストにデコードしてください。UTF-8 対応、ブラウザで実行されます。`)
};

const zh_tb_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的文本转二进制转换器。将文本转换为8位二进制,并将二进制解码回文本。兼容UTF-8,在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_tool_description", locale)
	if (locale === "en") return en_tb_tool_description(inputs)
	if (locale === "es") return es_tb_tool_description(inputs)
	if (locale === "de") return de_tb_tool_description(inputs)
	if (locale === "nl") return nl_tb_tool_description(inputs)
	if (locale === "fr") return fr_tb_tool_description(inputs)
	if (locale === "it") return it_tb_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_tb_tool_description(inputs)
	if (locale === "pt") return pt_tb_tool_description(inputs)
	if (locale === "ja") return ja_tb_tool_description(inputs)
	return zh_tb_tool_description(inputs)
};